"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToJsonObject = exports.castToEnum = exports.castToValues = void 0;
function castToValues(values) {
    const set = new Set(values);
    return (value, defaultValue) => {
        if (!set.has(value)) {
            // Use this to help debug
            console.error("castToValues", value, Object.values(values).slice(0, 4));
            if (defaultValue) {
                return defaultValue;
            }
            else {
                throw new Error("Value is not assignable to values");
            }
        }
        return value;
    };
}
exports.castToValues = castToValues;
/**
 * We often have a string in the database, which we need to convert to an enum.
 *
 *
 * @param enumObj
 * @returns
 */
function castToEnum(enumObj) {
    const set = new Set(Object.values(enumObj));
    return (value, defaultValue) => {
        const v = set.has(value);
        if (!v) {
            // Use this to help debug
            // console.error("castToEnum", value, [...set].slice(0, 4));
            if (defaultValue) {
                return defaultValue;
            }
            else {
                throw new Error("Value is not assignable to enumeration");
            }
        }
        return value;
    };
}
exports.castToEnum = castToEnum;
function castToJsonObject(value) {
    if (value == null) {
        return {};
    }
    else if (typeof value === "object" && !Array.isArray(value)) {
        return value;
    }
    else {
        // We could probably simply return empty here...
        // but it's dangerous since it might be used somehow
        throw new Error("Not a JSON Object are invalid");
    }
}
exports.castToJsonObject = castToJsonObject;
